
<div id="main" class="app-main">
  <router-view></router-view>
</div>
